import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_TARIFF = createActionTypes('FETCH_TARIFF');
export const CREATE_TARIFF = createActionTypes('CREATE_TARIFF');
export const DELETE_TARIFF = createActionTypes('DELETE_TARIFF');
export const UPDATE_TARIFF = createActionTypes('UPDATE_TARIFF');
export const GET_TARIFF = createActionTypes('GET_TARIFF');

export const UPDATE_TARIFF_SLOT = createActionTypes('UPDATE_TARIFF_SLOT');
